export const contentPadding = (isSidebarCollapsed:boolean) => {
    return isSidebarCollapsed ?"pl-5 pr-5":''
};
